import React from 'react';
import { useIntl } from 'react-intl';

import { CSSEditor } from 'components/Editors/components/Editor.style';
import { JRCButton } from 'components/JRCButton/JRCButton';
import { WidgetArticleTextContent } from 'jamespot-user-api';

import { JRCWidgetArticleTextProps } from './JRCWidgetArticleText';

export const JRCWidgetArticleTextEditor = ({
    content,
    onSave,
}: {
    content: WidgetArticleTextContent;
    onSave: (content: Partial<JRCWidgetArticleTextProps>) => void;
    onChange: (content: Partial<JRCWidgetArticleTextProps>, override?: boolean) => void;
}) => {
    const intl = useIntl();
    return (
        <CSSEditor>
            <JRCButton onClick={() => onSave(content)} variant={'outlined'} minWidth={'100%'}>
                {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
            </JRCButton>
        </CSSEditor>
    );
};
